/**
 * 자주 쓰는 기간 프리셋 → { from, to } (YYYY-MM-DD).
 * 로컬(브라우저=조직 tz) 기준 — toISOString()은 UTC라 KST에서 하루 밀리므로 금지.
 * admin·team-manager 동일 사본 (kr-holidays와 같은 정책) —
 * team-manager의 date-preset-sync.test.ts가 동기화를 강제한다.
 */
export function resolveDatePresetRange(
  preset: string,
  today: Date = new Date(),
): { from: string; to: string } {
  const pad = (n: number) => String(n).padStart(2, "0");
  const toISO = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  if (preset === "thisWeek") {
    const dow = today.getDay();
    const monday = new Date(today);
    monday.setDate(today.getDate() - (dow === 0 ? 6 : dow - 1));
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    return { from: toISO(monday), to: toISO(sunday) };
  }
  if (preset === "lastWeek") {
    const lastWeekEnd = new Date(today);
    lastWeekEnd.setDate(today.getDate() - 7);
    const dow = lastWeekEnd.getDay();
    const monday = new Date(lastWeekEnd);
    monday.setDate(lastWeekEnd.getDate() - (dow === 0 ? 6 : dow - 1));
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    return { from: toISO(monday), to: toISO(sunday) };
  }
  if (preset === "thisMonth") {
    const first = new Date(today.getFullYear(), today.getMonth(), 1);
    const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return { from: toISO(first), to: toISO(last) };
  }
  if (preset === "lastMonth") {
    const first = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const last = new Date(today.getFullYear(), today.getMonth(), 0);
    return { from: toISO(first), to: toISO(last) };
  }
  if (preset === "last3Months") {
    const first = new Date(today.getFullYear(), today.getMonth() - 3, 1);
    return { from: toISO(first), to: toISO(today) };
  }
  return { from: "", to: "" };
}
